import React from 'react';
import { Sparkles } from 'lucide-react';

export interface FixesHeadingProps {
  title: string;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  style?: React.CSSProperties;
}

/**
 * Heading for the Fixes board: the lime sparkle tile the AI-generated surfaces use, the
 * title and summary, and a right-aligned action slot.
 */
const FixesHeading: React.FC<FixesHeadingProps> = ({ title, description, actions, style }) => (
  <div style={{ marginBottom: 24, ...style }}>
    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
        <div
          style={{
            width: 40,
            height: 40,
            flex: 'none',
            borderRadius: 'var(--radius-md)',
            background: 'var(--lime-soft)',
            border: '1px solid var(--lime-soft-border)',
            color: 'var(--accent-ink)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Sparkles size={19} />
        </div>
        <div style={{ minWidth: 0 }}>
          <h1
            style={{
              margin: 0,
              fontSize: 22,
              fontWeight: 700,
              letterSpacing: 'var(--tracking-heading)',
              color: 'var(--text-primary)',
            }}
          >
            {title}
          </h1>
          {description && (
            <p style={{ margin: '3px 0 0', fontSize: 13.5, color: 'var(--text-secondary)' }}>{description}</p>
          )}
        </div>
      </div>
      {actions && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 'none', flexWrap: 'wrap' }}>{actions}</div>
      )}
    </div>
  </div>
);

export default FixesHeading;
